import axiosInstance from "../helpers/axiosInstance"

// 25 orders * ~3s/order Natura SAP latency worst-case = ~75s; give some slack.
const REQUEST_TIMEOUT_MS = 90_000

export const fetchNfeStatus = async (orderNumbers) => {
  const { data } = await axiosInstance.post(
    `${process.env.REACT_APP_PLATFORM_URL}/api/v1/natura-operations/nfe-status`,
    { order_numbers: orderNumbers },
    { timeout: REQUEST_TIMEOUT_MS }
  )
  return data
}
